var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-outbound-metrics",class:_vm.$vuetify.theme.dark? 'basic-metrics__dark':''},[_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"OutBoundDetailGraph"}})])}
var staticRenderFns = []

export { render, staticRenderFns }